'use client';

import React from 'react';
import styles from './ApproachSteps.module.scss';

export interface ApproachStep {
  icon: string;
  title: string;
  description: string;
  details: string[];
}

interface ApproachStepsProps {
  title: string;
  steps: ApproachStep[];
  className?: string;
}

export function ApproachSteps({
  title,
  steps,
  className
}: ApproachStepsProps) {
  return (
    <section className={`${styles.approach} ${className || ''}`}>
      <h2 className={styles.sectionTitle}>{title}</h2>
      <div className={styles.approachSteps}>
        {steps.map((step, index) => (
          <div key={index} className={styles.approachStep}>
            <div className={styles.stepIcon}>{step.icon}</div>
            <h3 className={styles.stepTitle}>{step.title}</h3>
            <p className={styles.stepDescription}>{step.description}</p>
            <ul className={styles.stepDetails}>
              {step.details.map((detail, idx) => (
                <li key={idx}>{detail}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </section>
  );
}

export default ApproachSteps;